// extracted by mini-css-extract-plugin
export default {"container":"DateIcon_container","month":"DateIcon_month","date":"DateIcon_date"};